import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TaxDemandBill = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    gpName: '',
    year: '',
    billDate: '',
    ownerName: '',
    houseNo: '',
    billNo: '',
    electricityTax: { previous: '', current: '' },
    generalTax: { previous: '', current: '' }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: { ...prev[parent], [child]: value }
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-[#f4f6f9] py-5 px-2 font-sans">
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 10mm;
            }
            body {
              visibility: hidden;
              background: white !important;
            }
            #printable-area {
              visibility: visible;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              padding: 10mm;
              display: block !important;
              color: black !important;
            }
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      {/* Main Form */}
      <div className="w-full bg-white border border-gray-300 shadow-sm rounded-sm overflow-x-auto no-print">
        <div className="bg-[#fff9e6] py-2 px-4 border-b border-gray-300 min-w-[1000px] flex justify-between items-center gap-2">
          <h2 className="text-[#b71c1c] text-left shrink text-[14px] sm:text-[17px] font-bold flex items-center  gap-2">
            <span className="text-blue-600 text-xl leading-none">✹</span> करमागणी बील (नोटीस)
          </h2>
          <button onClick={() => navigate(-1)} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print whitespace-nowrap shrink-0">
              मागे जा
            </button>
        </div>

        <div className="p-6 min-w-[1000px]">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-10 gap-y-6 mb-8">
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ग्रामपंचायत निवडा</label>
              <select name="gpName" value={formData.gpName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">ग्रामपंचायत निवडा</option>
                <option value="धामणी">धामणी</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">वर्ष निवडा</label>
              <select name="year" value={formData.year} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">वर्ष निवडा</option>
                <option value="2025-26">2025-26</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">करमागणी बिलाची दिनांक</label>
              <input type="date" name="billDate" value={formData.billDate} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="flex flex-col gap-1 md:col-span-2">
              <label className="text-[13px] font-bold text-[#333]">खातेदाराचे नाव</label>
              <input type="text" name="ownerName" placeholder="खातेदाराचे नाव" value={formData.ownerName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label className="text-[13px] font-bold text-[#333]">घर क्रमांक</label>
                  <input type="text" name="houseNo" placeholder="घर क्रमांक" value={formData.houseNo} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-[13px] font-bold text-[#333]">बील क्रमांक</label>
                  <input type="text" name="billNo" placeholder="बील क्रमांक" value={formData.billNo} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
                </div>
              </div>
            </div>
          </div>

          {/* Tax Rows */}
          <div className="space-y-8">
            {/* Electricity Tax Row */}
            <div className="grid grid-cols-3 gap-x-10 items-end">
              <div className="flex flex-col gap-1">
                <label className="text-[13px] font-bold text-[#333] text-center mb-1">कराचा प्रकार</label>
                <input readOnly value="विजकर" className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-gray-100 outline-none text-center" />
              </div>
              <div className="col-span-2">
                <label className="text-[13px] font-bold text-[#333] text-center block mb-1">रक्कम</label>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex flex-col gap-1 relative">
                    <span className="absolute -top-3 left-1/2 -translate-x-1/2 text-[10px] font-bold text-gray-400">.</span>
                    <input name="electricityTax.previous" value={formData.electricityTax.previous} onChange={handleChange} placeholder="मागील" className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
                  </div>
                  <div className="flex flex-col gap-1 relative">
                    <span className="absolute -top-3 left-1/2 -translate-x-1/2 text-[10px] font-bold text-gray-400">.</span>
                    <input name="electricityTax.current" value={formData.electricityTax.current} onChange={handleChange} placeholder="चालू" className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
                  </div>
                </div>
              </div>
            </div>

            {/* General Tax Row */}
            <div className="grid grid-cols-3 gap-x-10 items-end">
              <div className="flex flex-col gap-1">
                <label className="text-[13px] font-bold text-[#333] text-center mb-1">कराचा प्रकार</label>
                <input readOnly value="सामान्य" className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-gray-100 outline-none text-center" />
              </div>
              <div className="col-span-2">
                <label className="text-[13px] font-bold text-[#333] text-center block mb-1">रक्कम</label>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex flex-col gap-1 relative">
                    <span className="absolute -top-3 left-1/2 -translate-x-1/2 text-[10px] font-bold text-gray-400">.</span>
                    <input name="generalTax.previous" value={formData.generalTax.previous} onChange={handleChange} placeholder="मागील" className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
                  </div>
                  <div className="flex flex-col gap-1 relative">
                    <span className="absolute -top-3 left-1/2 -translate-x-1/2 text-[10px] font-bold text-gray-400">.</span>
                    <input name="generalTax.current" value={formData.generalTax.current} onChange={handleChange} placeholder="चालू" className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 flex gap-4 justify-center">
            <button onClick={handlePrint} className="bg-[#00a65a] text-white px-20 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#008d4c]">Save</button>
            <button className="bg-[#f39c12] text-white px-10 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#e08e0b]">Generate Document</button>
          </div>

          <div className="mt-8 border border-gray-300 rounded-sm min-h-[400px] bg-white"></div>

          <div className="mt-4">
            <button className="bg-[#f4f4f4] border border-[#ddd] text-[#444] px-5 py-1.5 rounded-sm text-xs flex items-center gap-2 hover:bg-[#e8e8e8]">
              <span>🖨️</span> Print
            </button>
          </div>
        </div>
      </div>

      {/* Printable Area */}
      <div id="printable-area" className="hidden print:block font-serif text-black bg-white">
        <div className="text-center mb-10 border-b-2 border-black pb-4">
          <h1 className="text-[24px] font-bold">ग्रामपंचायत कार्यालय: {formData.gpName}</h1>
          <p className="text-[18px] font-bold mt-1 text-red-600">कर मागणी बिल (नोटीस)</p>
          <p className="text-[14px]">सन {formData.year}</p>
        </div>

        <div className="flex justify-between mb-8 text-[15px]">
          <div>खातेदाराचे नाव: <span className="font-bold underline">{formData.ownerName}</span></div>
          <div className="text-right">
            <p>घर क्र.: {formData.houseNo}</p>
            <p>बील क्र.: {formData.billNo}</p>
            <p>दिनांक: {formData.billDate}</p>
          </div>
        </div>

        <table className="w-full border-collapse border border-black text-[15px] mb-10">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-black px-2 py-2 text-center" rowSpan="2">अ.क्र.</th>
              <th className="border border-black px-2 py-2 text-center" rowSpan="2">कराचा प्रकार</th>
              <th className="border border-black px-2 py-2 text-center" colSpan="2">मागील थकबाकी</th>
              <th className="border border-black px-2 py-2 text-center" colSpan="2">चालू वर्षाची मागणी</th>
              <th className="border border-black px-2 py-2 text-center" rowSpan="2">एकूण रक्कम</th>
            </tr>
            <tr className="bg-gray-100">
              <th className="border border-black px-2 py-1 text-center">मुद्दल</th>
              <th className="border border-black px-2 py-1 text-center">व्याज</th>
              <th className="border border-black px-2 py-1 text-center">मुद्दल</th>
              <th className="border border-black px-2 py-1 text-center">व्याज</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-black px-2 py-2 text-center">1</td>
              <td className="border border-black px-2 py-2 text-center">विजकर</td>
              <td className="border border-black px-2 py-2 text-center">{formData.electricityTax.previous}</td>
              <td className="border border-black px-2 py-2 text-center">0</td>
              <td className="border border-black px-2 py-2 text-center">{formData.electricityTax.current}</td>
              <td className="border border-black px-2 py-2 text-center">0</td>
              <td className="border border-black px-2 py-2 text-center font-bold">
                {Number(formData.electricityTax.previous || 0) + Number(formData.electricityTax.current || 0)}
              </td>
            </tr>
            <tr>
              <td className="border border-black px-2 py-2 text-center">2</td>
              <td className="border border-black px-2 py-2 text-center">सामान्य कर</td>
              <td className="border border-black px-2 py-2 text-center">{formData.generalTax.previous}</td>
              <td className="border border-black px-2 py-2 text-center">0</td>
              <td className="border border-black px-2 py-2 text-center">{formData.generalTax.current}</td>
              <td className="border border-black px-2 py-2 text-center">0</td>
              <td className="border border-black px-2 py-2 text-center font-bold">
                {Number(formData.generalTax.previous || 0) + Number(formData.generalTax.current || 0)}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="flex justify-between items-end mt-20 pr-10 pl-10 font-bold text-center">
          <div></div>
          <div>
            <p>ग्रामसेवक /ग्रामविकास अधिकारी</p>
            <p>ग्रामपंचायत {formData.gpName}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxDemandBill;
